// Copyright (c) 2022 Deere & Company

import {
    createErrorMessage,
    createSuccessMessage,
} from '../../../../sharedmodules/action-creators/alert-messages';
import { getStore } from '../../../../configmodules/store-reducer-config/store';
import { translate } from '../../../../sharedmodules/services/translation-service';

export const errorAlertBar = (errorObject) => {

    const { dispatch } = getStore();

    if (typeof errorObject.message === 'string') {

        errorObject.isTranslated ?
            dispatch(createErrorMessage(errorObject.message)) :
            dispatch(createErrorMessage(translate(errorObject.message)));

    } else {

        dispatch(createErrorMessage(translate('ERROR_UNHANDLED')));

    }

};

export const createErrorObject = (message, isTranslated = true) => ({ isTranslated, message });

export const successAlertBar = (message) => {

    const { dispatch } = getStore();

    dispatch(createSuccessMessage(translate(message)));

};
